import clsx from 'clsx'
import React from 'react'

import { useConfigurationStore } from '@stores'

import backgroundImageLandscape from '@assets/demo-preview/background-landscape.png'
import gameLogoLandscape from '@assets/demo-preview/game-logo-landscape.png'
import gameLogo from '@assets/demo-preview/game-logo.png'
import gamePlayLandscape from '@assets/demo-preview/gameplay-landscape.png'
import gamePlay from '@assets/demo-preview/gameplay.png'
import backgroundImage from '@assets/demo-preview/portraitBackground.png'

import backgroundImageLandscapeCompact from '@assets/demo-preview/ultraTight-background-landscape.png'
import gameLogoLandscapeCompact from '@assets/demo-preview/ultraTight-game-logo-landscape.png'
import gameLogoCompact from '@assets/demo-preview/ultraTight-game-logo.png'
import gamePlayLandscapeCompact from '@assets/demo-preview/ultraTight-gameplay-landscape.png'
import gamePlayCompact from '@assets/demo-preview/ultraTight-gameplay.png'
import backgroundImageCompact from '@assets/demo-preview/ultraTight-portraitBackground.png'
import { BaseGameType, ViewportType } from 'game-ui-types'

const Preview: React.FC = () => {
    const viewport = useConfigurationStore((state) => state.viewport)
    const gameType = useConfigurationStore((state) => state.gameType)

    console.log(gameType)

    // TODO: fix game type mapping
    const base = BaseGameType.SLOT_CONFIG_A
    const ultraTight = BaseGameType.SLOT_CONFIG_B

    const gamePlayClasses = clsx('', {
        'w-[1112px] h-[620px]': viewport === ViewportType.MOBILE_LANDSCAPE && gameType === base,
        'w-[1480px] h-[820px] mt-[15px]': viewport === ViewportType.DESKTOP && gameType === base,
        'mt-[-104px]': viewport === ViewportType.MOBILE_PORTRAIT && gameType === ultraTight,
        'w-[715px] h-[720px] mt-[-70px]': viewport === ViewportType.MOBILE_LANDSCAPE && gameType === ultraTight,
        'w-[935px] h-[933px] mt-[-65px]': viewport === ViewportType.DESKTOP && gameType === ultraTight,
    })

    const gamePlayWrapperClasses = clsx('absolute w-full', {
        'top-[177px]': viewport === ViewportType.MOBILE_PORTRAIT && gameType === base,
        'top-[12px]': viewport === ViewportType.MOBILE_LANDSCAPE && gameType === base,
        'top-[15px]': viewport === ViewportType.DESKTOP && gameType === base,
        'top-[143px]': viewport === ViewportType.MOBILE_PORTRAIT && gameType === ultraTight,
        'top-[4px]': viewport === ViewportType.MOBILE_LANDSCAPE && gameType === ultraTight,
        'top-[10px]': viewport === ViewportType.DESKTOP && gameType === ultraTight,
    })

    let background, play, logo

    switch (viewport) {
        case ViewportType.MOBILE_PORTRAIT:
            background = gameType === base ? backgroundImage : backgroundImageCompact
            play = gameType === base ? gamePlay : gamePlayCompact
            logo = gameType === base ? gameLogo : gameLogoCompact
            break
        default:
            background = gameType === base ? backgroundImageLandscape : backgroundImageLandscapeCompact
            play = gameType === base ? gamePlayLandscape : gamePlayLandscapeCompact
            logo = gameType === base ? gameLogoLandscape : gameLogoLandscapeCompact
    }

    return (
        <>
            <img src={background} className="w-full h-full object-fill" />
            <div className={gamePlayWrapperClasses}>
                <img src={logo} className="relative" style={{ margin: '0 auto' }} />
                <img src={play} className={gamePlayClasses} style={{ marginLeft: 'auto', marginRight: 'auto' }} />
            </div>
        </>
    )
}

export default Preview
